// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"Subtitle_subtitle__fvSfR","alignLeft":"Subtitle_alignLeft__aKSBh","alignCenter":"Subtitle_alignCenter__pyHx_","alignRight":"Subtitle_alignRight__8ANL5"};